import DOMPurify from "dompurify";

export const stripHtml = (value) => {
  if (!value) return "";
  const clean = DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
    FORBID_TAGS: ["style", "script"],
  });
  return clean.replace(/\s+/g, " ").trim();
};
